import styled from "styled-components";
import { Text } from '../../components/UI/generalLayout/Layout.styled';
import Colors from "../../constants/Colors";
import useResponsiveInfo from "../../hooks/useResponsiveInfo";

//color: Colors.SPM800, fontWeight: 'bold', fontSize: 14
export const CriarAgendaText = styled(Text)`
    color: ${Colors.SPM800};
    font-weight: bold;
    font-size: 14px;
`
//<Text style={{ fontSize: 14 }} color={Colors.GRAY400}>
export const GrayText = styled(Text)`
    color: ${Colors.GRAY400};
    font-size: 14px;
`
// marginBottom: 10, width: isMobile? '100%':'37%' }
export const CalendarContainer = styled.div<{isMobile:boolean}>`
    margin-bottom: 10px;
    width: ${props=>props.isMobile? '100%':'37%'};
`
//flexDirection: 'row', display: 'flex', backgroundColor: Colors.SPM50, width: 327, marginTop: 20
export const ConsiderWeekendContainer = styled.div`
    flex-direction: row;
    display: flex;
    background-color: ${Colors.SPM50};
    width: 327px;
`
//style={{ width: isMobile? '100%':'60%', padding: 5, marginTop: -20 }}
export const AgendaFieldsContainer = styled.div<{isMobile:boolean}>`
    width: ${props=>props.isMobile? '100%':'60%'};
    padding: 5px;
    margin-top: -20px;


`
//flexDirection: isMobile? 'column':'row', display: 'flex'
export const ResponsiveContainerCriarAgenda = styled.div<{ isMobile?: boolean }>`
    flex-direction: ${(props) => (props.isMobile ? "column" : "row")};
    display: flex;

    @media screen and (min-width: 700px) and (max-width:1223px){
        flex-direction: row;
    }
`;
//div style={{ display:'flex', justifyContent:'flex-end'}}
export const BottomButtonContainer = styled.div<{isMobile:boolean}>`
    display:flex;
    justify-content: flex-end;
    margin-bottom: ${props=>props.isMobile? '10%':''};
`

export const LoadingModalStyled = styled.div`
    border-radius: 8px;
    justify-content: center;
    text-align: center;
    align-items: center;
    align-self: center;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 200px;
    height: 200px;
    transform: translate(-50%, -50%);
    max-width: 95vw;
    background-color: white;
`